<style src='./TreeList.scss' lang='scss'></style>

<script>
  import Icon from '@/components/Icon/Icon'

  export default {
    name: 'HpTreeList',
    props: ['element'],
    methods: {
      /**
       * Toggles visibility of submenus.
       * @param {Event} e The click event fired by the arrow of menu point
       */
      toggleChildren (e) {
        e.preventDefault()

        if (this.$el.hasAttribute('data-open')) {
          this.collapseSection(this.$el.querySelector('ul'))
        } else {
          this.expandSection(this.$el.querySelector('ul'))
        }

        this.$el.hasAttribute('data-open') ? this.$el.removeAttribute('data-open') : this.$el.setAttribute('data-open')
      },
      collapseSection (element) {
        if (!element) {
          return
        }

        // get the height of the element's inner content, regardless of its actual size
        const sectionHeight = element.scrollHeight

        // temporarily disable all css transitions
        const elementTransition = element.style.transition
        element.style.transition = ''

        // on the next frame (as soon as the previous style change has taken effect),
        // explicitly set the element's height to its current pixel height, so we
        // aren't transitioning out of 'auto'
        requestAnimationFrame(() => {
          element.style.height = sectionHeight + 'px'
          element.style.transition = elementTransition

          // on the next frame (as soon as the previous style change has taken effect),
          // have the element transition to height: 0
          requestAnimationFrame(() => {
            element.style.height = '0'
          })
        })
      },
      expandSection (element) {
        if (!element) {
          return
        }

        // get the height of the element's inner content, regardless of its actual size
        const sectionHeight = element.scrollHeight

        // have the element transition to the height of its inner content
        element.style.height = sectionHeight + 'px'

        // when the next css transition finishes (which should be the one we just triggered)
        const transitionend = () => {
          // remove this event listener so it only gets triggered once
          element.removeEventListener('transitionend', transitionend)

          // remove "height" from the element's inline styles, so it can return to its initial value
          element.style.height = 'auto'
        }

        element.addEventListener('transitionend', transitionend)
      }
    },
    components: {
      'hp-icon': Icon
    }
  }
</script>

<template>
  <li data-component='TreeList'>
    <a :href='element.url'>
      <p>{{ element.title }}</p>
      <span data-arrow-down @click='toggleChildren' v-if='element.navigations && element.navigations.length'>
				<hp-icon type='arrow' />
			</span>
    </a>

    <ul v-if='element.navigations && element.navigations.length'>
      <hp-tree-list v-for='(subElement, index2) in element.navigations' :element='subElement'
                    :key='index2'></hp-tree-list>
    </ul>
  </li>
</template>
